import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.splice";
import { __assign, __awaiter, __generator } from "tslib";
import { isUndef } from '@/lib/utils';
import Vue from 'vue';
import { chooseWXPay } from '@/lib/script/pay';

var cityList = function cityList() {
  return {
    list: [],
    loaded: false,
    requesting: false
  };
};

var digitalList = function digitalList() {
  return {
    list: [],
    loaded: false,
    requesting: false
  };
};

var lessonList = function lessonList() {
  return {
    list: [],
    loaded: false,
    requesting: false
  };
};

var m = {
  namespaced: true,
  state: {
    cityList: cityList(),
    digitalList: digitalList(),
    lessonList: lessonList(),
    fragmentDetailMap: {},
    keyMap: {},
    atlasDetailMap: {},
    cityDetailMap: {},
    digitalDetailMap: {}
  },
  mutations: {
    /**
     * 线路列表
     */
    concatCityList: function concatCityList(state, _a) {
      var list = _a.list;
      state.cityList.list = state.cityList.list.concat(list);
    },
    resetCityList: function resetCityList(state) {
      state.cityList.list.splice(0);
      state.cityList.loaded = false;
      state.cityList.requesting = false;
    },
    setCityListLoaded: function setCityListLoaded(state, _a) {
      var loaded = _a.loaded;
      state.cityList.loaded = loaded;
    },
    setCityListReq: function setCityListReq(state, _a) {
      var req = _a.req;
      state.cityList.requesting = req;
    },

    /**
     * 数字藏品
     */
    concatDigitalList: function concatDigitalList(state, _a) {
      var list = _a.list;
      state.digitalList.list = state.digitalList.list.concat(list);
    },
    resetDigitalList: function resetDigitalList(state) {
      state.digitalList.list.splice(0);
      state.digitalList.loaded = false;
      state.digitalList.requesting = false;
    },
    setDigitalListLoaded: function setDigitalListLoaded(state, _a) {
      var loaded = _a.loaded;
      state.digitalList.loaded = loaded;
    },
    setDigitalListReq: function setDigitalListReq(state, _a) {
      var req = _a.req;
      state.digitalList.requesting = req;
    },

    /**
     * 课程
     */
    concatLessonList: function concatLessonList(state, _a) {
      var list = _a.list;
      state.lessonList.list = state.lessonList.list.concat(list);
    },
    setLessonListLoaded: function setLessonListLoaded(state, _a) {
      var loaded = _a.loaded;
      state.lessonList.loaded = loaded;
    },
    setLessonListReq: function setLessonListReq(state, _a) {
      var req = _a.req;
      state.lessonList.requesting = req;
    },
    setFragmentDetailMap: function setFragmentDetailMap(state, _a) {
      var key = _a.key,
          data = _a.data;
      Vue.set(state.fragmentDetailMap, key, data);
    },
    setKeyMap: function setKeyMap(state, _a) {
      var key = _a.key,
          str = _a.str;
      Vue.set(state.keyMap, key, str);
    },
    setAtlasDetailMap: function setAtlasDetailMap(state, _a) {
      var id = _a.id,
          detail = _a.detail;
      Vue.set(state.atlasDetailMap, id, detail);
    },
    setCityDetailMap: function setCityDetailMap(state, _a) {
      var id = _a.id,
          detail = _a.detail;
      Vue.set(state.cityDetailMap, id, detail);
    },
    setDigitalDetailMap: function setDigitalDetailMap(state, _a) {
      var id = _a.id,
          detail = _a.detail;
      Vue.set(state.digitalDetailMap, id, detail);
    },
    resetList: function resetList(state) {
      Vue.set(state, 'cityList', cityList());
      Vue.set(state, 'digitalList', digitalList());
      Vue.set(state, 'lessonList', lessonList());
    }
  },
  actions: {
    /**
     * 获取线路列表
     */
    getCityList: function getCityList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, data;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.cityList;

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setCityListReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/atlas/city_list', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('concatCityList', {
                  list: data || []
                });

                if ((data || []).length < count) {
                  commit('setCityListLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setCityListReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取数字藏品
     */
    getDigitalList: function getDigitalList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, data;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.digitalList;

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setDigitalListReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/atlas/digital_list', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('concatDigitalList', {
                  list: data || []
                });

                if ((data || []).length < count) {
                  commit('setDigitalListLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setDigitalListReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 课程列表
     */
    getLessonList: function getLessonList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, data;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.lessonList;

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setLessonListReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/atlas/lesson_list', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('concatLessonList', {
                  list: data || []
                });

                if ((data || []).length < count) {
                  commit('setLessonListLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setLessonListReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 图鉴详情弹窗
     */
    getDetail: function getDetail(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var id = _b.id,
          type = _b.type;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, data;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/detail', {
                params: {
                  id: id,
                  type: type
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('setDetail', data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 赠卡/求卡弹窗内容详情
     */
    getFragmenDetail: function getFragmenDetail(_a, _b) {
      var _c;

      var commit = _a.commit,
          rootState = _a.rootState;
      var key = _b.key,
          _d = _b.forceUpdate,
          forceUpdate = _d === void 0 ? false : _d;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/atlas/fragment_detail', {
                params: {
                  key: key
                }
              })];

            case 1:
              response = _e.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                if (rdata.data && !isUndef(rdata.data.can)) {
                  rdata.data.can = ((_c = rootState.user.basicInfo) === null || _c === void 0 ? void 0 : _c.id) === rdata.data.user_id ? -2 : rdata.data.can;
                }

                commit('setFragmentDetailMap', {
                  key: key,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 赠卡/求卡弹窗key
     * @param {} |fragment_id|是|9|int|碎片id|
     * @param {} |type|是|send|string|类型：send=赠卡，seek=求卡|
     */
    getKey: function getKey(context, _a) {
      var _b;

      var fragmentId = _a.fragmentId,
          type = _a.type;
      return __awaiter(this, void 0, void 0, function () {
        var key, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              key = fragmentId + "_" + type;

              if (context.state.keyMap[key]) {
                return [2
                /*return*/
                , {
                  status: 0,
                  data: context.state.keyMap[key]
                }];
              }

              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/atlas/get_str', {
                fragment_id: fragmentId,
                type: type
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setKeyMap', {
                  key: key,
                  str: (_b = rdata === null || rdata === void 0 ? void 0 : rdata.data) === null || _b === void 0 ? void 0 : _b.key
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 合成碎片
     * @param {} |id|是|1|int|图鉴id|
     * @param {} |type|是|lesson|string|类型：lesson=课程，city=线路，camp=营地，digital=数字藏品|
     */
    synthesis: function synthesis(context, _a) {
      var id = _a.id,
          type = _a.type;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/atlas/synthesis', {
                id: id,
                type: type
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 弹窗-领取碎片/同意求卡并赠送
     * @param {string} key atlas/get_str接口的返回值
     */
    accept: function accept(context, _a) {
      var key = _a.key,
          id = _a.id,
          fragmentType = _a.fragmentType;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/atlas/accept', {
                key: key
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                switch (fragmentType) {
                  case 'camp':
                    if (context.state.cityList.list.find(function (item) {
                      return item.id === id;
                    })) {
                      context.commit('resetCityList');
                      context.dispatch('getCityList', {
                        offset: 0,
                        count: 10
                      });
                    }

                    break;

                  case 'city':
                    break;

                  case 'digital':
                    if (context.state.digitalList.list.find(function (item) {
                      return item.id === id;
                    })) {
                      context.commit('resetDigitalList');
                      context.dispatch('getDigitalList', {
                        offset: 0,
                        count: 10
                      });
                    }

                    break;

                  case 'lesson':
                    break;
                }
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 数字藏品创建订单
     * @param {number} id 藏品id
     */
    createOrder: function createOrder(context, id) {
      return __awaiter(this, void 0, void 0, function () {
        var orderResponse, orderRdata, data, ret;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/collection/order', {
                collection_id: id
              })];

            case 1:
              orderResponse = _a.sent();
              orderRdata = orderResponse.data;

              if (orderRdata.status !== 0) {
                return [2
                /*return*/
                , {
                  status: 'error',
                  message: orderRdata.message
                }];
              }

              data = orderRdata.data;
              if (!data.need_pay) return [3
              /*break*/
              , 3];
              return [4
              /*yield*/
              , chooseWXPay(data.parameters)];

            case 2:
              ret = _a.sent();
              return [2
              /*return*/
              , __assign(__assign({}, ret), {
                type: 'jsapi',
                orderId: data.id
              })];

            case 3:
              return [2
              /*return*/
              , {
                status: 'success',
                orderId: data.id
              }];
          }
        });
      });
    },

    /**
     * 获取订单状态
     * @param {number} orderId 订单id
     */
    getPayStatus: function getPayStatus(context, orderId) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/collection/order_status', {
                params: {
                  id: orderId
                }
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 图鉴详情弹窗
     * @param {} id | 图鉴id
     * @param {} type |类型：lesson=课程，city=线路，camp=营地，digital=数字藏品
     */
    getAtlasDetail: function getAtlasDetail(context, _a) {
      var id = _a.id,
          type = _a.type,
          _b = _a.forceUpdate,
          forceUpdate = _b === void 0 ? true : _b;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (context.state.atlasDetailMap[id] && !forceUpdate) {
                return [2
                /*return*/
                , {
                  status: 0,
                  data: context.state.atlasDetailMap[id]
                }];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/atlas/detail', {
                params: {
                  id: id,
                  type: type
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setAtlasDetailMap', {
                  id: id,
                  detail: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 线路详情
     * @param {} id | 图鉴id
     */
    getCityDetail: function getCityDetail(context, _a) {
      var id = _a.id,
          _b = _a.forceUpdate,
          forceUpdate = _b === void 0 ? false : _b;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (context.state.cityDetailMap[id] && !forceUpdate) {
                return [2
                /*return*/
                , {
                  status: 0,
                  data: context.state.cityDetailMap[id]
                }];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/atlas/city_detail', {
                params: {
                  id: id
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setCityDetailMap', {
                  id: id,
                  detail: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 数字藏品详情
     * @param {} id | 图鉴id
     */
    getDigitalDetail: function getDigitalDetail(context, _a) {
      var id = _a.id,
          _b = _a.forceUpdate,
          forceUpdate = _b === void 0 ? false : _b;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (context.state.digitalDetailMap[id] && !forceUpdate) {
                return [2
                /*return*/
                , {
                  status: 0,
                  data: context.state.digitalDetailMap[id]
                }];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/atlas/digital_detail', {
                params: {
                  id: id
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setDigitalDetailMap', {
                  id: id,
                  detail: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取路线分享卡
     * @param {} id | 图鉴id
     */
    getCityShareCard: function getCityShareCard(context, id) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/atlas/city_card', {
                params: {
                  id: id
                }
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;